
export function compiler(scheme, item, util, variables, appId) {
  async function schemeCompiler(scheme, item, appId) {
    let value = null;
    if (scheme.type === "array") {
      // get properties value for array childs for each application item
      if (Number(scheme.is_static)) {
        value = new Array(
          await getChildsPropertiesObject(scheme.childs, item, appId)
        );
      } else {
        value = await getArrayOfItemsWithProperties(scheme, item, appId);
      }
    }

    if (scheme.type === "object") {
      // get properties value for object childs
      if (Number(scheme.current_item)) {
        value = await getItemWithProperties(scheme, item);
      } else {
        value = await getChildsPropertiesObject(scheme.childs, item, appId);
      }
    }
    if (scheme.type === "property") {
      // get properties value
      value = await getFieldValue(scheme, item, appId);
    }

    if (typeof scheme === "object" && typeof scheme.type === 'undefined') {
      const result = {};

      for (const key in scheme) {
        if (scheme.hasOwnProperty(key)) {
          const element = scheme[key];
          const res = await schemeCompiler(element, item, appId);
          result[key] = res[element.property_name];
        }
      }

      return result;
    }

    return { [scheme.property_name]: value };
  }

  /* Get properties value for array childs in scheme, for each application filtered item. */
  async function getArrayOfItemsWithProperties(scheme, item, recievedApp) {
    const app = await util.gudhub.getApp(Number(scheme.app_id));
    let filteredItems = await filterItems(
      scheme.filter,
      app.items_list,
      recievedApp,
      item
    );

    if(scheme.isSortable && scheme.field_id_to_sort && scheme.field_id_to_sort !== '') {

      let itemsWithValue = filteredItems.flatMap(item => {
        let fieldToSort = item.fields.find(field => field.field_id == scheme.field_id_to_sort);
        if(!fieldToSort || fieldToSort.field_value == '') {
          return [];
        } else {
          return item;
        }
      });

      let itemsWithoutValue = filteredItems.filter(item => {
        if(!itemsWithValue.includes(item)) {
          return item;
        }
      });

      itemsWithValue = itemsWithValue.sort((a, b) => {
        if(scheme.sortType == 'desc') {
          return b.fields.find(field => field.field_id == scheme.field_id_to_sort).field_value - a.fields.find(field => field.field_id == scheme.field_id_to_sort).field_value;
        } else {
          return a.fields.find(field => field.field_id == scheme.field_id_to_sort).field_value - b.fields.find(field => field.field_id == scheme.field_id_to_sort).field_value;
        }
      })

      filteredItems = [ ...itemsWithValue, ...itemsWithoutValue ];

    }

    if(scheme.offset) {
      let offset;
      if(scheme.use_variables_for_limit_and_offset && variables) {
        offset = variables[scheme.offset];
      } else {
        offset = /^[0-9]+$/.test(scheme.offset) ? scheme.offset : 0;
      }
      filteredItems = filteredItems.slice(offset);
    }

    if(scheme.limit) {
      let limit;
      if(scheme.use_variables_for_limit_and_offset && variables) {
        limit = variables[scheme.limit];
      } else {
        limit = /^[0-9]+$/.test(scheme.limit) || 0;
      }
      if(limit !== 0) {
        filteredItems = filteredItems.slice(0, limit);
      }
    }

    const arrayOfItemsWithProperties =  filteredItems.map(async (item) => {
      return getChildsPropertiesObject(scheme.childs, item, app.app_id);
    });
    return Promise.all(arrayOfItemsWithProperties);
  }

  async function getItemWithProperties(scheme, item) {
    const app = await util.gudhub.getApp(scheme.app_id);
    const items = app.items_list || [];

    return getChildsPropertiesObject(scheme.childs, item || items[0], app.app_id);
  }

  /* Get properties value for object childs in scheme. */
  async function getChildsPropertiesObject(properties, item, appId) {
    const propertiesArray = await properties.map(async (child) => {
      return schemeCompiler(child, item, appId);
    });
    const resolvedPropertiesArray = await Promise.all(propertiesArray);
    return resolvedPropertiesArray.reduce((acc, object) => {
      return { ...acc, ...object };
    }, {});
  }

  /* Get property value based on interpretation value */
  async function getFieldValue(scheme, item, appId) {
    switch (scheme.property_type) {
      case "static":
        return scheme.static_field_value;
      case "variable":
        switch (scheme.variable_type) {
          case "app_id":
            return appId;
          // case "user_id":
          //   resolve(storage.getUser().user_id);
          //   break;
          case "current_item":
          default:
            return `${appId}.${item.item_id}`;
        }

      case "field_id":
        return scheme.field_id;

      case "function":
        if(typeof scheme.function === 'function') {
          let result = scheme.function(item, appId, util.gudhub, ...scheme.args);
          return result;
        } else {
          const func = new Function('item, appId, gudhub', 'return (async ' + scheme.function + ')(item, appId, gudhub)');
          let result = await func(item, appId, util.gudhub);
          return result;
        }

      case "field_value":
      default:
        if(!scheme.field_id && scheme.name_space) {
          scheme.field_id = await util.gudhub.getFieldIdByNameSpace(appId, scheme.name_space);
        }
        if (Boolean(Number(scheme.interpretation))) {
          let interpretatedValue = await util.gudhub.getInterpretationById(Number(appId), Number(item.item_id), Number(scheme.field_id), 'value');
          return interpretatedValue;
        } else {
          let value = await util.gudhub.getFieldValue(Number(appId), Number(item.item_id), Number(scheme.field_id))
          return value;
        }
    }
  }

  async function getFilteredItems(filtersList, element_app_id, app_id, item_id, itemsList) {
    const modified_filters_list = await util.gudhub.prefilter(
      JSON.parse(JSON.stringify(filtersList)),
      {
        element_app_id,
        app_id,
        item_id,
        ...variables
      }
    );
    return util.gudhub.filter(itemsList, [...modified_filters_list, ...filtersList]);
  }

  /* Filter items by scheme filter */
  async function filterItems(
    filtersList = [],
    itemsList = [],
    appId = '',
    item = {}
  ) {
    return filtersList.length ? getFilteredItems(
      filtersList,
      appId,
      appId,
      item.item_id,
      itemsList
    ) : [...itemsList ];
  }

  return schemeCompiler(scheme, item, appId, variables);
}
